import { ThemeProvider } from "@mui/material/styles";
import { mainTheme } from "./theme/main";
import { Routes, Route, BrowserRouter } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import EbiOky from "./pages";
import { CssBaseline } from "@mui/material";

function App() {
  const basename = process.env.NODE_ENV === "production" ? "/donate" : "";
  return (
    <>
      <div className="App">
        <ThemeProvider theme={mainTheme}>
          <CssBaseline />
          <BrowserRouter basename={basename}>
            <Header />
            <EbiOky />
            <Footer />
          </BrowserRouter>
        </ThemeProvider>
      </div>
    </>
  );
}

export default App;
